import { SET_ACTIVE_SPECIALTY } from './SpecialtyTypes';
import { DEFAULT_SPECIALTY, SPECIALTY_IDS } from 'config/specialtyConfig';

const getInitialSpecialty = () => {
  try {
    const stored = localStorage.getItem('activeSpecialty');
    if (stored && SPECIALTY_IDS.includes(stored)) {
      return stored;
    }
  } catch (e) {
    // localStorage unavailable
  }
  return DEFAULT_SPECIALTY;
};

const initialState = {
  activeSpecialty: getInitialSpecialty(),
};

const specialtyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_SPECIALTY:
      return { ...state, activeSpecialty: action.payload };
    default:
      return state;
  }
};

export default specialtyReducer;
